import axios from '../../../../utils/request';


function EDIT_DATA(params) {
    return axios.post("/score/AInvite/inviteSetting",
        {id: params}
    )
}

function SUBMIT_ADD(params) {
    return axios.post("/score/AInvite/inviteSettingPost", {...params})
}

export default {
    EDIT_DATA,
    SUBMIT_ADD,
};
